import { render } from "./ContactBox.vue?vue&type=template&id=590d3e1e&scoped=true"
import script from "./ContactBox.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ContactBox.vue?vue&type=script&charset=utf-8&lang=js"

import "./ContactBox.vue?vue&type=style&index=0&id=590d3e1e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590d3e1e"]])

export default __exports__